import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';

import {
  InputField,
  SelectField
} from '../../form';

class SearchAPIBuilder extends Component {
  render() {
    const { formValues, website } = this.props;
    const queryString = Object.keys(formValues).map(key => `${key}=${encodeURIComponent(formValues[key] || '')}`).join('&');
    const builtUrl = `https://${website.search_domain}/v2/publisher/jobs?${queryString}`;
    return (
      <div>
        <form
          className='m-t'
        >
          <Field
            type='text'
            name='pid'
            placeholder='website pixel id'
            label='Pixel Id'
            component={InputField}
            disabled
          />
          
          <Field
            type='text'
            name='q'
            placeholder='search query'
            label='Query'
            component={InputField}
          />
          
          <Field
            type='text'
            name='l'
            placeholder='search location'
            label='Location'
            component={InputField}
          />

          <Field
            type='text'
            name='bool'
            placeholder='Query type is boolean or not'
            label='Boolean'
            component={SelectField}
            options={[
              { label: '1', value: '1' },
              { label: '0', value: '0' },
            ]}
            normalize={(e) => e.value}
          />
          
          <Field
            type='text'
            name='useragent'
            placeholder='user agent'
            label='User Agent'
            component={InputField}
          />

          <Field
            type='text'
            name='userip'
            placeholder='user ip'
            label='User Ip'
            component={InputField}
          />

          <Field
            type='decimal'
            name='min_cpc'
            placeholder='minimum cpc'
            label='Minimum CPC'
            component={InputField}
          />

          <Field
            type='number'
            name='page'
            placeholder='page number'
            label='Page Number'
            component={InputField}
          />

          <Field
            type='number'
            name='limit'
            placeholder='results limit per request'
            label='Results Limit'
            component={InputField}
          />

          <Field
            type='number'
            name='radius'
            placeholder='search radius'
            label='Search Radius'
            component={InputField}
          />

          <Field
            type='text'
            name='sort'
            placeholder='sort results by'
            label='Sort By'
            component={SelectField}
            options={[
              { label: 'relevance', value: 'relevance' },
              { label: 'date', value: 'date' },
              { label: 'cpc', value: 'cpc' }
            ]}
            normalize={(e) => e.value}
          />

          <Field
            type='text'
            name='id'
            placeholder='job ids. example: 123|234'
            label='Job Ids'
            component={InputField}
          />

          <Field
            type='text'
            name='category'
            placeholder='job category. example: Sales and Related Occupations|Production Occupations'
            label='Job Category'
            component={InputField}
          />

          <Field
            type='text'
            name='fields'
            placeholder='fields. example: title|description'
            label='Fields'
            component={InputField}
          />

          <Field
            type='text'
            name='full_desc'
            placeholder='get full job description'
            label='Full Job Description'
            component={SelectField}
            options={[
              { label: '1', value: '1' },
              { label: '0', value: '0' },
            ]}
            normalize={(e) => e.value}
          />

          <Field
            type='text'
            name='use_userip'
            placeholder='use userip in search'
            label='Use User IP'
            component={SelectField}
            options={[
              { label: '1', value: '1' },
              { label: '0', value: '0' },
            ]}
            normalize={(e) => e.value}
          />
        </form>

        <label className="control-label" htmlFor='final-url'>Final URL</label>
        <pre>{builtUrl}</pre>

        <Button
          bsStyle='primary'
          onClick={() => window.open(builtUrl, '_blank')}
        >
          Open in New Tab
        </Button>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'SearchAPIBuilderForm'
});

const mapStateToProps = (state, ownProps) => {
  const { form } = state;
  const formValues = get(form, 'SearchAPIBuilderForm.values', {});

  const initialValues = {
    pid: ownProps.pixelId,
    q: 'sales',
    l: 'new york',
    bool: '0',
    useragent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/75.0.3770.142 Safari/537.36',
    userip: '72.14.192.0',
    min_cpc: '0.10',
    page: '1',
    limit: '15',
    radius: '25',
    sort: 'relevance',
    id: null,
    category: 'Sales and Related Occupations',
    fields: 'title|description|company',
    full_desc: '0',
    use_userip: '0'
  };

  return { initialValues, formValues };
};

export default connect(mapStateToProps)(ResourceForm(SearchAPIBuilder));
